const DEFAULTS = {
    once: true,
    threshold: 0.1,
    rootMargin: "0px 0px -10% 0px",
  };
  
  function normalize(value) {
    // v-reveal
    if (value === true || value == null) return {};
    // v-reveal="150"  (delay)
    if (typeof value === "number") return { delay: value };
    // v-reveal="{ ... }"
    if (typeof value === "object") return value || {};
    return {};
  }
  
  export const vReveal = {
    mounted(el, binding) {
      el.classList.add("reveal");
  
      const raw = normalize(binding.value);
      const opts = { ...DEFAULTS, ...raw };
  
      if (typeof raw.delay === "number") {
        el.style.transitionDelay = `${raw.delay}ms`;
      }
  
      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              el.classList.add("reveal--in");
              if (opts.once) io.unobserve(el);
            } else if (!opts.once) {
              el.classList.remove("reveal--in");
            }
          }
        },
        { threshold: opts.threshold, rootMargin: opts.rootMargin }
      );
  
      el.__reveal_io__ = io; // stash for cleanup
      io.observe(el);
    },
  
    unmounted(el) {
      if (el.__reveal_io__) {
        el.__reveal_io__.disconnect();
        delete el.__reveal_io__;
      }
    },
  };
  